import { render, staticRenderFns } from "./Category.vue?vue&type=template&id=3ee7844f&scoped=true"
import script from "../script/category.js?vue&type=script&lang=js&external"
export * from "../script/category.js?vue&type=script&lang=js&external"
import style0 from "./Category.vue?vue&type=style&index=0&id=3ee7844f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee7844f",
  null
  
)

export default component.exports